// Email and phone taken from the Impressum on konradwalz.com. LinkedIn URL is still a placeholder.
export const contact = {
  email: 'konrad.walz@icloud.com',
  whatsappNumber: '4915773491110', // international format, digits only
  linkedinUrl: 'https://www.linkedin.com/in/konradwalz',
  privacyUrl: '/datenschutz',
};
